import React, { useRef, useState } from "react";
import { X, Minus, Volume2, VolumeX, Maximize2 } from "lucide-react";
import SmartVideoBlock from "./SmartVideoBlock";
import { isYouTubeUrl } from "../utils/videoHelper";

/**
 * FloatingVideoWidget — Product detail page ke liye bottom-right floating
 * (PiP jaisa) video player. Backend se jo bhi video URL aaye (direct
 * mp4/webm file ya YouTube link), yeh khud detect karke sahi tarike se
 * play kar deta hai.
 */
function FloatingVideoWidget({ src, title }) {
  const videoRef = useRef(null);

  const [closed, setClosed] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const [muted, setMuted] = useState(true);

  if (!src || closed) return null;

  const isYT = isYouTubeUrl(src);

  const toggleMute = (e) => {
    e.stopPropagation();
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setMuted(videoRef.current.muted);
  };

  return (
    <div
      className={`floating-product-video-widget ${minimized ? "is-minimized" : ""}`}
      role="complementary"
      aria-label="Product video"
    >
      <div className="floating-video-controls">
        {/* <button
          type="button"
          className="fv-ctrl-btn"
          onClick={(e) => {
            e.stopPropagation();
            setMinimized((prev) => !prev);
          }}
          aria-label={minimized ? "Expand video" : "Minimize video"}
        >
          {minimized ? <Maximize2 size={13} /> : <Minus size={13} />}
        </button> */}

        {/* {!isYT && !minimized && (
          <button
            type="button"
            className="fv-ctrl-btn"
            onClick={toggleMute}
            aria-label={muted ? "Unmute video" : "Mute video"}
          >
            {muted ? <VolumeX size={13} /> : <Volume2 size={13} />}
          </button>
        )} */}

        <button
          type="button"
          className="fv-ctrl-btn fv-close-btn"
          onClick={(e) => {
            e.stopPropagation();
            setClosed(true);
          }}
          aria-label="Close video"
        >
          <X size={14} />
        </button>
      </div>

      {!minimized && (
        <div className="floating-video-frame">
          <SmartVideoBlock
            videoRef={videoRef}
            src={src}
            className="floating-video-asset"
            autoPlay
            muted
            loop
          />
          {title && <span className="floating-video-tag">{title}</span>}
        </div>
      )}

      {minimized && <div className="floating-video-minimized-bar">Product video</div>}
    </div>
  );
}

export default FloatingVideoWidget;
